<div class="body" [formGroup]="formGroup">

    <div class="content">

        <mat-form-field class="width" [appearance]="appearance">
            <mat-label class="label">Aktuelles Passwort</mat-label>
            <input formControlName="oldPassword" matInput placeholder="Ihr Passwort" [readonly]="!editMode" type="{{!displayPasswords.oldPassword? 'password': 'text'}}" />
            <button mat-icon-button matSuffix (click)="displayPasswords.oldPassword = !displayPasswords.oldPassword">
                <mat-icon>{{!displayPasswords.oldPassword? 'visibility': 'visibility_off'}}</mat-icon>
            </button>
        </mat-form-field>
    
        <mat-form-field class="width" [appearance]="appearance">
            <mat-label class="label">Neues Password</mat-label>
            <input formControlName="newPassword" matInput placeholder="Mindestens 8 Zeichen" [readonly]="!editMode" type="{{!displayPasswords.newPassword? 'password': 'text'}}" />
            <button mat-icon-button matSuffix (click)="displayPasswords.newPassword = !displayPasswords.newPassword">
                <mat-icon>{{!displayPasswords.newPassword? 'visibility': 'visibility_off'}}</mat-icon>
            </button>
        </mat-form-field>
    
        <mat-form-field class="width" [appearance]="appearance">
            <mat-label class="label">Neues Passwort wiederholen</mat-label>
            <input formControlName="confirmPassword" matInput placeholder="Muss mit neuem Passwort übereinstimmen" [readonly]="!editMode" type="{{!displayPasswords.confirmPassword? 'password': 'text'}}" />
            <button mat-icon-button matSuffix (click)="displayPasswords.confirmPassword = !displayPasswords.confirmPassword">
                <mat-icon>{{!displayPasswords.confirmPassword? 'visibility': 'visibility_off'}}</mat-icon>
            </button>
            <mat-error *ngIf="formGroup.errors?.passwordMismatch">
                Die Passwörter stimmen nicht überein
            </mat-error>
        </mat-form-field>

    </div>

</div>
